import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-workflow_delete",
  "use": "icon-workflow_delete-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-workflow_delete\">\n  <g>\n    <path d=\"M24 12h0v14.054C24 27.13 22.993 28 21.75 28H8.25C7.007 28 6 27.129 6 26.054V12.065h0M4 8.5h22M10 2.5h10\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\" />\n    <rect x=\"11\" y=\"13\" width=\"2\" height=\"11\" rx=\"1\" />\n    <rect x=\"17\" y=\"13\" width=\"2\" height=\"11\" rx=\"1\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol